const GameManagementActionType = {
  GET_GAMES: 'GET_GAMES',
  SAVE_GAMES: 'SAVE_GAMES',
  RESET_GAMES: 'RESET_GAMES',
  EXPORT_GAMES: 'EXPORT_GAMES',

  GET_GAME: 'GET_GAME',
  SAVE_GAME: 'SAVE_GAME',
  RESET_GAME: 'RESET_GAME',

  SET_GAME_MAINTENANCE: 'SET_GAME_MAINTENANCE',
  RESET_GAME_MAINTENANCE: 'RESET_GAME_MAINTENANCE',

  GET_GAME_BADGES: 'GET_GAME_BADGES',
  SAVE_GAME_BADGES: 'SAVE_GAME_BADGES',
  RESET_GAME_BADGES: 'RESET_GAME_BADGES',

  GET_GAME_SYSTEM_GROUPS: 'GET_GAME_SYSTEM_GROUPS',
  SAVE_GAME_SYSTEM_GROUPS: 'SAVE_GAME_SYSTEM_GROUPS',
  RESET_GAME_SYSTEM_GROUPS: 'RESET_GAME_SYSTEM_GROUPS',

  ADD_GAME_TO_SYSTEM_GROUP: 'ADD_GAME_TO_SYSTEM_GROUP',
  MANAGE_GAME_BADGES: 'MANAGE_GAME_BADGES',

  SET_GAMES_MAINTENANCE: 'SET_GAMES_MAINTENANCE',
  RESET_GAMES_MAINTENANCE: 'RESET_GAMES_MAINTENANCE',

  ADD_GAMES_TO_SYSTEM_GROUP: 'ADD_GAMES_TO_SYSTEM_GROUP',
  MANAGE_GAMES_BADGES: 'MANAGE_GAMES_BADGES',

  GET_GAME_GROUPS: 'GET_GAME_GROUPS',
  SAVE_GAME_GROUPS: 'SAVE_GAME_GROUPS',
  RESET_GAME_GROUPS: 'RESET_GAME_GROUPS',

  GET_CSV_GAMES: 'GET_CSV_GAMES',
  SAVE_CSV_GAMES: 'SAVE_CSV_GAMES',
  RESET_CSV_GAMES: 'RESET_CSV_GAMES',
  GET_CSV_ORDERED_GAMES: 'GET_CSV_ORDERED_GAMES',

  CHANGE_GAME_MANAGEMENT_ENDED_STATUS: 'CHANGE_GAME_MANAGEMENT_ENDED_STATUS',

  GET_GAME_GROUP: 'GET_GAME_GROUP',
  SAVE_GAME_GROUP: 'SAVE_GAME_GROUP',
  RESET_GAME_GROUP: 'RESET_GAME_GROUP',

  CREATE_GAME_GROUP: 'CREATE_GAME_GROUP',
  DELETE_GAME_GROUP: 'DELETE_GAME_GROUP',
  EDIT_GAME_GROUP: 'EDIT_GAME_GROUP',

  CHANGE_GAME_GROUP_STATUS: 'CHANGE_GAME_GROUP_STATUS',

  CHANGE_GAME_STATUS: 'CHANGE_GAME_STATUS',

  GET_GAME_TYPES: 'GET_GAME_TYPES',
  SAVE_GAME_TYPES: 'SAVE_GAME_TYPES',
  RESET_GAME_TYPES: 'RESET_GAME_TYPES',

  GET_GAME_TYPE: 'GET_GAME_TYPE',
  SAVE_GAME_TYPE: 'SAVE_GAME_TYPE',
  RESET_GAME_TYPE: 'RESET_GAME_TYPE',

  CREATE_GAME_TYPE: 'CREATE_GAME_TYPE',
  EDIT_GAME_TYPE: 'EDIT_GAME_TYPE',
  DELETE_GAME_TYPE: 'DELETE_GAME_TYPE',
  CHANGE_GAME_TYPE_STATE: 'CHANGE_GAME_TYPE_STATE',

  DELETE_GAME_TYPE_GAMES: 'DELETE_GAME_TYPE_GAMES',

  GET_CSV_GAME_TYPE_GAMES: 'GET_CSV_GAME_TYPE_GAMES',
  SAVE_CSV_GAME_TYPE_GAMES: 'SAVE_CSV_GAME_TYPE_GAMES',
  RESET_CSV_GAME_TYPE_GAMES: 'RESET_CSV_GAME_TYPE_GAMES',
};

export default GameManagementActionType;
